import appendQuery from 'append-query'
import humps from 'humps'

import { interpolate } from '../../../shared/utils/commonUtils'

const trackingUri = '{passportAPIServerHost}/tracking'
let trackingIframe

const configureTrackBuilder = props => {
  const baseUri = interpolate(trackingUri, props)
  return params => {
    if (!trackingIframe) {
      const dom = document.createElement('iframe')
      dom.setAttribute('style', 'display: none;')
      trackingIframe = document.body.appendChild(dom)
    }

    const _params = Object.keys(params)
      .reduce((acc, key) => Object.assign(acc, { [humps.decamelize(key)]: params[key] }), {})
    trackingIframe.src = appendQuery(baseUri, { ..._params })
  }
}

export default configureTrackBuilder
